// import jsPDF from "jspdf";
// import employeeLogo from "../../images/employee.png";

// export const PurchasePrint = (vendor,ledger,items,getTotal,pay,user) => {
//   let doc = new jsPDF();
// console.log('printing')
//   doc.setFontSize(18);
//   doc.setFontStyle("bold");
//   doc.text(localStorage.getItem("company"), 105, 22);
//   doc.setFontSize(26);
//   doc.text("PURCHASE ORDER", 105, 35);

//   doc.setFontSize(12);
//   doc.setFontStyle("normal");

//   doc.text("Date:", 150, 45);
//   let currentDate = new Date();
//   let formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
// //   doc.text(state.date, 165, 45);
// doc.text(` ${formattedDate}`, 165, 45);

//   if (vendor) {
//     doc.setFontSize(14);
//     doc.setFontStyle("bold");
//     doc.text("SHIP TO", 100, 48);

//     doc.text("VENDOR", 21, 48);
//     doc.setFontSize(12);
//     doc.setFontStyle("normal");
//     doc.text(vendor?.companyName, 20, 55);
//     doc.text(vendor?.dept || "", 20, 60);
//     doc.text(vendor?.street || "", 20, 65);
//     doc.text(vendor?.city || "", 20, 70);
//     doc.text(vendor?.phone || "", 20, 75);
//   } else {
//     doc.setFontSize(14);
//     doc.setFontStyle("bold");
//     doc.text("SHIP TO", 100, 48);
//     doc.text("LEDGER", 21, 48);
//     doc.setFontSize(12);
//     doc.setFontStyle("normal");

//     doc.text(ledger?.name || "", 20, 55);
//     doc.text(ledger?.address || "", 20, 60);
//     doc.text(ledger?.ledgerType || "", 20, 65);
//   }

//   doc.text(user?.name || "", 100, 55);
//   doc.text(user?.company_name || "", 100, 60);
//   doc.text(user?.address?.street || "", 100, 65);
//   doc.text( user?.address?.city || "", 100, 70);
//   doc.text( user?.address?.phone || "", 100, 75);




//   doc.setFontSize(14);
//   doc.setFontStyle("bold");
//   doc.text("Sr #", 21, 90);
//   doc.text("Item", 40, 90);
//   doc.text("Description", 80, 90);
//   doc.text("Quantity", 140, 90);
//   doc.text("Price", 170, 90);
//   doc.cell(20, 84, 170, 8, " ");
//   // let  descriptionLocation;
//   // let priceLocation;
//   // let quantity;
//   // totalPaid = 34;
//   // totalBalance = 69;
//   // totalBalance = 170;
//   // totalBalance = 139;


//   let y = 92;
//   items.map((item, index) => {
//     // if (item.description.length > 50) {
//     //   descriptionLocation = 34;
//     // } else {
//     //   descriptionLocation = 38;
//     // }
//     let itemPrice = item.newPrice
//       ? parseInt(item.newPrice)
//       : parseInt(item.companyPrice);
//     let qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
//     doc.setFontSize(14);
//     doc.setFontStyle("bold");
//     doc.cell(20, y, 12, 6, " ");
//     doc.cell(32, y, 35, 6, " ");
//     doc.cell(67, y, 70, 6, " ");
//     doc.cell(137, y, 25, 6, " ");
//     doc.cell(162, y, 28, 6, " ");

//     doc.setFontSize(12);
//     doc.setFontStyle("normal");
//     doc.text((index + 1).toString(), 22, y + 5);
//     doc.text(item.name, 34, y + 5);
//     doc.text(item.description, 69, y + 5);
//     doc.text(itemPrice.toString(), 170, y + 5);
//     doc.text(qty.toString(), 139, y + 5);
//     y = y + 6;
//     doc.setFontSize(10);

//     doc.text(localStorage.getItem("terms") || "", 65, 270);

//     doc.text("Powered by www.hardwarepakistan.com", 75, 280);
//     doc.text("0342-5588269", 85, 290);

//     if (y >= 240) {
//       doc.addPage();
//       y = 20;
//     }
//   });

//   y = y + 8;

//   doc.cell(20, y, 100, 8, " ");
//   doc.cell(20, y + 8, 100, 30, " ");

//   doc.setFontSize(14);
//   doc.text("Comments Or Special Instructions", 22, y + 6);
//   doc.text("TOTAL", 138, y);
//   doc.text("PAID", 138, y + 7);
//   doc.text("REMAINING", 138, y + 14);
//   doc.text(getTotal.toString(), 168, y);
//     doc.text(pay.toString(), 168, y + 7);

//   let rems = getTotal - pay;
//   doc.text(rems.toString(), 168, y + 14);
//   y = y + 23;

//   let img = new Image();

//   let baseUrl = localStorage.getItem("base_url");

//   if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
//     let snapshot = employeeLogo;
//     img.src = snapshot;
//   } else {
//     let snapshot = localStorage.getItem("base_url");
//     img.src = snapshot;
//   }
//   doc.addImage(img, "png", 0, 0, 40, 40);

//   if (window.innerWidth <= 600) {
//     doc.save("reciept");
//   } else {
//     doc.autoPrint();
//     window.open(doc.output("bloburl"), "_blank");
//   }
// };




import html2pdf from "html2pdf.js";
import employeeLogo from "../../images/employee.png";

export const PurchasePrint = (vendor, ledger, items, getTotal, pay, user) => {
  const container = document.createElement("div");
  container.style.fontFamily = "Arial, sans-serif";
  container.style.margin = "20px";

  // Header Section
  const header = document.createElement("div");
  header.style.textAlign = "center";
  header.innerHTML = `
    <h2 style='margin: 0;'>${localStorage.getItem("company")}</h2>
    <h3 style='margin: 5px 0;'>PURCHASE ORDER</h3>
    <p style='margin: 0;'>Date: ${new Date().toLocaleDateString()}</p>
  `;
  container.appendChild(header);

  // Vendor or Ledger Details
  const detailsSection = document.createElement("div");
  detailsSection.style.display = "flex";
  detailsSection.style.justifyContent = "space-between";
  detailsSection.style.marginTop = "20px";

  const leftDetails = document.createElement("div");
  const rightDetails = document.createElement("div");

  if (vendor) {
    leftDetails.innerHTML = `
      <h4>VENDOR</h4>
      <p>${vendor.companyName || ""}</p>
      <p>${vendor.dept || ""}</p>
      <p>${vendor.street || ""}</p>
      <p>${vendor.city || ""}</p>
      <p>${vendor.phone || ""}</p>
    `;
  } else {
    leftDetails.innerHTML = `
      <h4>LEDGER</h4>
      <p>${ledger.name || ""}</p>
      <p>${ledger.address || ""}</p>
      <p>${ledger.ledgerType || ""}</p>
    `;
  }

  rightDetails.innerHTML = `
        <h4>Company Details</h4>
    <p>${user?.name || ""}</p>
    <p>${user?.company_name || ""}</p>
    <p>${user?.address?.street || ""}</p>
    <p>${user?.address?.city || ""}</p>
    <p>${user?.address?.phone || ""}</p>
  `;

  detailsSection.appendChild(leftDetails);
  detailsSection.appendChild(rightDetails);
  container.appendChild(detailsSection);

  // Table Header
  const table = document.createElement("table");
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";
  table.style.marginTop = "20px";

  const tableHeader = document.createElement("thead");
  tableHeader.innerHTML = `
    <tr>
      <th style='border: 1px solid #000; padding: 5px;'>Sr #</th>
      <th style='border: 1px solid #000; padding: 5px;'>Item</th>
      <th style='border: 1px solid #000; padding: 5px;'>Description</th>
      <th style='border: 1px solid #000; padding: 5px;'>Quantity</th>
      <th style='border: 1px solid #000; padding: 5px;'>Price</th>
    </tr>
  `;
  table.appendChild(tableHeader);

  // Table Body
  const tableBody = document.createElement("tbody");
  let y = 0;

  items.forEach((item, index) => {
    const itemPrice = item.newPrice || item.companyPrice;
    const qty = item.newQuantity || 1;

    const row = document.createElement("tr");
    row.innerHTML = `
      <td style='border: 1px solid #000; padding: 5px;'>${index + 1}</td>
      <td style='border: 1px solid #000; padding: 5px;'>${item.name}</td>
      <td style='border: 1px solid #000; padding: 5px;'>${item.description}</td>
      <td style='border: 1px solid #000; padding: 5px;'>${qty}</td>
      <td style='border: 1px solid #000; padding: 5px;'>${itemPrice}</td>
    `;
    tableBody.appendChild(row);
    y++;
  });
  table.appendChild(tableBody);
  container.appendChild(table);

  // Footer Section
  const footer = document.createElement("div");
  footer.style.marginTop = "20px";
  footer.innerHTML = `
    <h4>Comments or Special Instructions</h4>
    <p>${localStorage.getItem("terms") || ""}</p>
    <div style='display: flex; justify-content: space-between;'>
      <p><strong>TOTAL:</strong> ${getTotal}</p>
      <p><strong>PAID:</strong> ${pay}</p>
      <p><strong>REMAINING:</strong> ${getTotal - pay}</p>
    </div>
  `;
  container.appendChild(footer);

  // Logo
  const img = document.createElement("img");
  img.src = localStorage.getItem("base_url") || employeeLogo;
  img.style.width = "100px";
  img.style.marginTop = "20px";
  container.prepend(img);




    let opt = {
      margin: 0,
      filename: "receipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
    };
  
  
    html2pdf()
      .from(container)
      .set(opt)
      .output("blob")
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
          newWindow.onload = function () {
            setTimeout(() => {
              newWindow.print();
            }, 100); // Wait a second for the PDF to load before printing
          };
        } else {
          alert("Please allow popups for this website");
        }
      });
};
